<template>
  <Component
    :is="getIcon"
    :name="type"
    class="h-6 w-6 mr-3 text-secondary-500 hover:text-secondary-800"
  />
</template>

<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps({
  service: {
    type: String,
    required: true,
  },
});

const iconMap: Record<string, string> = {
  messages: "EnvelopeIcon",
  "messages-logs": "TableCellsIcon",
  "queue-manager": "Bars3BottomLeftIcon",
  contacts: "UserIcon",
  groups: "UsersIcon",
  diary: "CalendarIcon",
  templates: "RectangleGroupIcon",
  diverts: "ArrowTrendingUpIcon",
  location: "MapPinIcon",
  "account-management": "AdjustmentsVerticalIcon",
  settings: "CogIcon",
  devices: "DevicePhoneMobileIcon",
  "smart-dashboard": "ComputerDesktopIcon",
  "quick-send": "Squares2X2Icon",
  "app-management": "DevicePhoneMobileIcon",
  "campaign-manager": "UserGroupIcon",
  "pager-events": "BaseSvgIcon",
};

const getIcon = computed(() => iconMap[props.service] || iconMap.messages);
const type = computed(() => (props.service == "pager-events" ? "PAGER" : ""));
</script>
